import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';

const TermsOfService = () => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language.startsWith('ar');

    return (
        <div className={`min-h-screen bg-page-gradient py-12 px-4 sm:px-6 lg:px-8 ${isArabic ? 'text-right' : 'text-left'}`}>
            <div className="max-w-4xl mx-auto bg-bg-card border border-black/5 rounded-xl shadow-2xl overflow-hidden p-8">
                <div className="mb-8 border-b border-gold/10 pb-6">
                    <div className="flex justify-between items-start mb-4">
                        <Link to="/" className="text-gold hover:text-white flex items-center gap-2 transition-colors">
                            {isArabic ? <>&rarr;</> : <>&larr;</>} {t('backToHome') || "Back to Home"}
                        </Link>
                        <LanguageSwitcher variant="dark" />
                    </div>
                    <h1 className="text-3xl font-bold text-text mb-2">{t('termsTitle') || "Terms of Service"}</h1>
                    <p className="text-text-muted text-sm">{t('lastUpdated') || "Last Updated"}: {new Date().toLocaleDateString(isArabic ? 'ar' : 'es')}</p>
                </div>

                <div className="prose prose-gray max-w-none text-text-muted space-y-6">
                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsIntroTitle')}</h2>
                        <p>{t('termsIntroText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsServicesTitle')}</h2>
                        <p>{t('termsServicesText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsAccountTitle')}</h2>
                        <p>{t('termsAccountText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsIntellectualPropertyTitle')}</h2>
                        <p>{t('termsIntellectualPropertyText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsLiabilityTitle')}</h2>
                        <p>{t('termsLiabilityText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsChangesTitle')}</h2>
                        <p>{t('termsChangesText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsGoverningLawTitle')}</h2>
                        <p>{t('termsGoverningLawText')}</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gold mb-3">{t('termsContactTitle')}</h2>
                        <p>{t('termsContactText')}</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
